export default {
    data() {
        return {
            inview: false
        }
    },
    mounted() {
        if ( 'IntersectionObserver' in window ) {
            let observer = new IntersectionObserver((entries, self) => {
                entries[0].isIntersecting && (this.inview = true);
            });

            observer.observe(this.$el);
        }
        else {
            this.inview = true;

            // --> IE 11
            // $(window).on('load scroll', () => {
            //     if ( !this.inview ) {
            //         this.inview = (window.innerHeight > this.$el.getBoundingClientRect().top);
            //     }
            // });
        }
    }
}